<template>
  <fts-client-modal
    width="1080px"
    :title="document.name"
    append-content-class="document-form-modal__body"
    class="fts-document-form-modal"
    :data-document-form-load="loading ? 'loading' : 'loaded'"
    @closed="reset"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <template #icon>
      <font-awesome-icon :icon="['far', 'file-pdf']" class="fts-file-pdf" v-if="document.typeId === 'pdf'" />
      <font-awesome-icon :icon="['far', 'file-alt']" class="fts-file-excel" v-else-if="document.typeId === 'spreadsheet'" />
      <font-awesome-icon :icon="['far', 'file-code']" class="fts-file-html" v-else-if="document.typeId === 'html'" />
      <font-awesome-icon :icon="['far', 'file']" class="fts-file-default" v-else />
    </template>
    <!-- body -->
    <template #body>
      <!-- spinner -->
      <div class="client-modal-spinner" v-if="loading">
        <fts-spinner show />
      </div>
      <!-- form -->
      <fts-form
        :form="form"
        :form-data="formData"
        :validator="$v.formData"
        :vector-id="moduleId"
        v-else
      />
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn
        text
        :disabled="loading"
        @click="close"
      >
        <font-awesome-icon :icon="['fas', 'times']" /> Close
      </fts-btn>
      
      <fts-btn
        color="primary"
        :disabled="loading"
        @click.native.prevent="done"
      >
        <font-awesome-icon :icon="['fas', 'check']" /> Done
      </fts-btn>
    </template>
  </fts-client-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import commons from "../commons/commons";
import { clientStore } from "../store/clientStore";
import { classificationStore } from '../store/classificationStore';

import FTSClientModal from './FTSClientModal';
import FTSForm from "./FTSForm";
import FTSBtn from "./FTSBtn";
import FTSSpinner from "./FTSSpinner";

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-form": FTSForm,
    "fts-btn": FTSBtn,
    "fts-spinner": FTSSpinner,
  },
  data: () => ({
    resolve: null,
    moduleId: null,
    listingId: null,
    document: {},
    documentFields: [],
    items: [],
    form: {},
    formData: {},
    filters: null,
    loading: false,
  }),
  validations() {
    let formData = {};
    try {
      // to:do remove commons.formElementVisibility
      // not compatible with formula script
      const fields = this.documentFields.filter((x) =>
        commons.formElementVisibility(x, this.formData)
      );
      formData = commons.getFormValidators(fields);
    } catch (err) {}
    return { formData };
  },
  methods: {
    async show({ moduleId, listingId, document, items, filters } = {}) {
      this.loading = true;
      this.moduleId = moduleId;
      this.listingId = listingId;
      this.document = document;
      this.items = items;
      this.filters = filters;
      classificationStore.dispatch("updateDocumentId", {
        documentId: this.document.id,
        vectorId: this.moduleId
      });

      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.$refs.ftsClientModal.show();

        const res = await clientStore.dispatch("loadDocumentForm", {
          moduleId: this.moduleId,
          listingId: this.listingId,
          templateId: this.document.id,
        });

        const documentFields = { ...res.data };
        this.documentFields = documentFields.rows.reduce(
          (arr, x) => arr.concat(x.items),
          []
        );

        this.form = res.data;
        this.loading = false;
      });
    },
    done() {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        this.$toasted.global.invalidFormValidate();
        return;
      }

      let payload = {
        moduleId: this.moduleId,
        listingId: this.listingId,
        document: this.document,
        items: this.items,
        filters: this.filters
      };

      if (this.formData != null) {
        let data = _.cloneDeep(this.formData);
        payload.inputs = data;
      }

      this.close();
      window.eventBus.$emit("showPDFDocument", payload);
    },
    close() {
      this.resolve && this.resolve();
      this.$refs.ftsClientModal.close();
    },
    reset() {
      classificationStore.dispatch("updateDocumentId", null);
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/vars.scss";

.fts-document-form-modal {
  .document-form-modal__body {
    padding-top: 2rem;
  }
}
</style>